import { CommonPageComponent } from './../../home/common-page/common-page.component';
import { DashboardService } from './../../home/services/dashboard.service';
import { DashboardComponent } from './../../home/dashboard/dashboard.component';
import { Component, OnInit, Inject, Input, Output, EventEmitter, Injectable} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import { MasterService } from './../../home/services/master.service';

@Component({
  selector: 'app-dashboard-modal',
  templateUrl: './dashboard-modal.component.html',
  styleUrls: ['./dashboard-modal.component.scss']
})
export class DashboardModalComponent implements OnInit {

  public dashboardModalData: any;
  public selectedBodyValue: any;
  public implantData: any;
  public implantValue: any;
  public implantModalData: any;
  public productTableData: any;
  public productItems: any;
  public bodyPartName: any;
  public filter: any;
  page = 1;
  pageIndex: number;
  pageSize: number;
  // tslint:disable-next-line:variable-name
  total_count: number;
  // tslint:disable-next-line:variable-name
  current_page: number;
  // tslint:disable-next-line:variable-name
  body_id: number;
  implantId: number;
  dashboardPage = 'dashboardModal_pagination';
  // tslint:disable-next-line:variable-name
  per_page: number;
  public selectedName = {
    bodyPartName: '',
    implantName: ''
  };
  selectedImplant: any;
  public selectedBodyPart: any;

  // tslint:disable-next-line:max-line-length
  constructor(public dialogRef: MatDialogRef<DashboardComponent>, @Inject(MAT_DIALOG_DATA) data, public dashboardService: DashboardService, public masterService: MasterService) {
    this.dashboardModalData = data.res;
    this.bodyPartName = data.name;
    this.selectedName.bodyPartName = data.name;

   }

  ngOnInit() {
    this.filter = {
      token: localStorage.getItem('token'),
      name: this.bodyPartName
    };
    this.getBodyPartData();
  }
  getBodyPartData() {
    // let page = e;
    this.masterService.getIndex('/body_parts/get_by_name', this.filter).subscribe(res => {
      // @ts-ignore
      this.intialBodyPartSelect(res.data.id);

    });

  }
  intialBodyPartSelect(id) {
    this.selectedBodyPart = id;
    this.dashboardService.getImplants(this.selectedBodyPart).subscribe(res => {
      this.implantData = res.data;
      if (this.implantData.hasOwnProperty(0)) {
        this.implantValue = this.implantData[0].id;
        this.selectedImplant = this.implantData[0].name;
        this.dashboardService.getModalImplantData(this.implantValue, this.selectedBodyValue).subscribe(resp => {
          this.implantModalData = resp.data;
        });
      }
    });
  }
  close() {
    this.dialogRef.close();
  }

  onBodyPartSelect(eve) {
    if (eve.target.selectedIndex === 0) { return; }
    this.selectedBodyValue = eve.target.value;
    this.selectedBodyPart = this.dashboardModalData[eve.target.selectedIndex - 1].id;
    this.dashboardService.getImplants(this.selectedBodyPart).subscribe(res => {
      this.implantData = res.data;
      this.selectedImplant = this.implantData[0].name;
    });
    this.implantSelected();
  }


  selected() {

  }

  implantSelected() {
    const implantId = this.implantValue;
     // let id = this.selectedValue.id;
    this.dashboardService.getModalImplantData(implantId, this.selectedBodyValue).subscribe( res => {
      this.implantModalData = res.data;
    });
  }

  openModalTable(bodyId, implantId) {
    this.body_id = bodyId;
    this.implantId = implantId;
    this.dashboardService.getModalListOfProducts(bodyId, implantId, this.page).subscribe( res => {
      this.productTableData = res;
      this.productItems = res.data.items;
      this.total_count = res.data.total;
      this.current_page = res.data.current_page;
      this.per_page = res.data.per_page;
    });
  }

  pageChange(eve) {
    this.page = eve;
    this.openModalTable(this.body_id, this.implantId);
  }
}
